import { wrappingInputRule } from '@tiptap/core';
import BulletList from '@tiptap/extension-bullet-list';

const ListItemName = 'listItem';
const TextStyleName = 'textStyle';

export const inputRegex = /^\s*([-+*])\s$/;

export default BulletList.extend({
  addCommands() {
    return {
      toggleBulletList:
        () =>
        ({ chain }) => {
          if (this.options.keepAttributes) {
            return chain()
              .toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
              .updateAttributes(ListItemName, {
                'data-list-type': 'bulleted',
                ...this.editor.getAttributes(TextStyleName),
              })
              .run();
          }
          return chain()
            .toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
            .updateAttributes(ListItemName, { 'data-list-type': 'bulleted' })
            .run();
        },
    };
  },
  addInputRules() {
    let inputRule = wrappingInputRule({
      find: inputRegex,
      type: this.type,
      getAttributes: () => ({ 'data-list-type': 'bulleted' }),
    });

    if (this.options.keepMarks || this.options.keepAttributes) {
      inputRule = wrappingInputRule({
        find: inputRegex,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: () => ({ 'data-list-type': 'bulleted', ...this.editor.getAttributes(TextStyleName) }),
        editor: this.editor,
      });
    }
    return [inputRule];
  },
});
